import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.promise.finally.js";
import "core-js/modules/web.dom-collections.iterator.js";
/* Styles */
import "../style/pages/insight.css";
import { useVuelidate } from "@vuelidate/core";
import { required, email, numeric, maxLength } from "@vuelidate/validators";
import axios from "axios";
//@ts-ignore
import { BREAKPOINT } from "@customTypes/BreakpointEnum";
import CommonModals from "./vue/CommonComponents/CommonModals";
var backgroundColorDoughnutCharts = ["#75bffa", "#479ff7", "#3374b4", "#1f4c7c", "#12335f"];
var dataOne = [20450, 108249, 207788, 149824, 121476];
var dataTwo = [45917, 194765, 448426, 160849, 122586];
var dataThree = [2294, 12239, 21797, 11838, 5917];
var dataFour = [2377, 14156, 26969, 14046, 6920];
//@ts-ignore
import PublicUserMenu from "./vue/PublicUserMenu.vue";
//@ts-ignore
import { useAppBanner } from "@wkComposables/useAppBanner";
//@ts-ignore
import { useFirebaseMessaging } from "@wkComposables/useFirebaseMessaging";
//@ts-ignore
import BaseInput from "@vueEntry/UIKitComponents/BaseInput.vue";
//@ts-ignore
import { useValidator } from "@wkComposables/useValidator";
//@ts-ignore
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
//@ts-ignore
import BaseTextarea from "@vueEntry/UIKitComponents/BaseTextarea.vue";
//@ts-ignore
import BaseAccordionItem from "@vueEntry/UIKitComponents/Accordion/BaseAccordionItem.vue";
//@ts-ignore
import BaseAccordionBtn from "@vueEntry/UIKitComponents/Accordion/BaseAccordionBtn.vue";
//@ts-ignore
import BaseAccordionContent from "@vueEntry/UIKitComponents/Accordion/BaseAccordionContent.vue";
//@ts-ignore
import SwiperCarousel from "@vueEntry/SwiperCarousel.vue";
//@ts-ignore
import SwiperSlide from "@vueEntry/SwiperCarousel/SwiperSlide.vue";
//@ts-ignore
import IntersectionObserverVue from "@vueEntry/IntersectionObserver/IntersectionObserverVue.vue";
//@ts-ignore
import IntersectionObservableVue from "@vueEntry/IntersectionObserver/IntersectionObservableVue.vue";
import { createApp, defineAsyncComponent } from "vue";
import { mapState, mapActions, createPinia } from "pinia";
import { useLoggedUserStore, usePublicUserMenuStore, useModalStore, useBaseStore
//@ts-ignore
} from "@store/index";
//@ts-ignore
import LanguageIcons from "@vueEntry/CommonComponents/LanguageIcons";
//@ts-ignore
import { useBreakpoints } from "@wkComposables/useBreakpoints";
//@ts-ignore
import { useTrustpilotWidget } from "@wkComposables/useTrustpilotWidget";
var insightApp = createApp({
  name: "WikiInsight",
  components: Object.assign(Object.assign(Object.assign({
    SwiperCarousel,
    SwiperSlide,
    IntersectionObserverVue,
    IntersectionObservableVue,
    BaseAccordionItem,
    BaseAccordionBtn,
    BaseAccordionContent,
    PublicUserMenu,
    BaseInput,
    BaseTextarea,
    BaseButton,
    //@ts-ignore
    cchart: defineAsyncComponent(() => import("@vueEntry/cchart"))
  }, CommonModals), {
    //@ts-ignore
    "async-dropdown": defineAsyncComponent(() => import("@vueEntry/UIKitComponents/BaseDropDown.vue"))
  }), LanguageIcons),
  setup() {
    var {
      isAppBannerVisible
    } = useAppBanner();
    var {
      showFirebaseSnackbar,
      snackbarTitle,
      snackbarBody,
      snackbarIcon,
      handleOnForegroundNotificationClick
    } = useFirebaseMessaging();
    var {
      isValid
    } = useValidator();
    var {
      isLarge
    } = useBreakpoints();
    useTrustpilotWidget();
    return {
      v$: useVuelidate(),
      isAppBannerVisible,
      isLarge,
      //useFirebaseMessaging
      showFirebaseSnackbar,
      snackbarTitle,
      snackbarBody,
      snackbarIcon,
      handleOnForegroundNotificationClick,
      isValid
    };
  },
  data() {
    return {
      charts: [],
      success: false,
      error: false,
      username: "",
      email: "",
      phone: "",
      agency_name: "",
      message: "",
      privacy: true,
      marketingConsent: false,
      mobile: false,
      isLoading: false,
      options: {
        type: "loop",
        perMove: 1,
        rewind: true,
        autoplay: false,
        drag: false,
        pauseOnHover: true,
        pauseOnFocus: true,
        perPage: 4,
        breakpoints: {
          991: {
            perPage: 2
          }
        },
        pagination: false,
        lazyLoad: "nearby",
        preloadPages: 3,
        gap: "1rem",
        classes: {
          arrows: "d-none"
        }
      },
      optionsFranchise: {
        type: "loop",
        perMove: 1,
        autoplay: true,
        rewind: false,
        speed: 600,
        interval: 1500,
        pauseOnHover: true,
        pauseOnFocus: true,
        perPage: 4,
        breakpoints: {
          576: {
            perPage: 1
          },
          992: {
            perPage: 2
          }
        },
        pagination: false,
        lazyLoad: "nearby",
        preloadPages: 3,
        gap: "1rem",
        classes: {
          arrows: "d-none"
        }
      },
      dataLinear: {
        // eslint-disable-next-line max-len
        labels: ["2016-01", "2016-04", "2016-07", "2016-10", "2017-01", "2017-04", "2017-07", "2017-10", "2018-01", "2018-04", "2018-07", "2018-10", "2019-01", "2019-04", "2019-07", "2019-10", "2020-01", "2020-04", "2020-07", "2020-10", "2021-01", "2021-04", "2021-07", "2021-10", "2022-01", "2022-04", "2022-07", "2022-10", "2023-01", "2023-04", "2023-07", "2023-10"],
        // eslint-disable-next-line max-len
        // ["Jan 01, 2016", "Apr 2016", "Jul 2016", "Oct 2016", "Jan 2017", "Apr 2017", "Jul 2017", "Oct 2017", "Jan 2018", "Apr 2018", "Jul 2018", "Oct 2018", "Jan 2019", "Apr 2019", "Jul 2019", "Oct 2019", "Jan 2020", "Apr 2020", "Jul 2020", "Oct 2020", "Jan 2021", "Apr 2021", "Jul 2021", "Oct 2021", "Jan 2022", "Apr 2022", "Jul 2022"],
        datasets: [{
          // eslint-disable-next-line max-len
          data: [112315, 140148, 120537, 143293, 121971, 145527, 122373, 152607, 127276, 153693, 130608, 167068, 138524, 159619, 137098, 168298, 117047, 116173, 141323, 183381, 162257, 201492, 172271, 212500, 181766, 218720, 208371, 166745, 184110, 157024],
          borderColor: "#2B5DFF",
          lineTension: 0,
          label: "",
          fill: false,
          borderCapStyle: "butt",
          pointBorderColor: "#3374b4",
          pointBorderWidth: 3,
          pointRadius: 4,
          pointBackgroundColor: "#FFF",
          pointHoverBorderWidth: 5,
          pointHoverRadius: 8
        }]
      },
      optionsLinear: {
        maintainAspectRatio: false,
        responsive: true,
        scales: {
          y: {
            min: 10000,
            max: 240000,
            ticks: {
              callback: value => value.toLocaleString()
            }
          },
          x: {
            type: "time",
            time: {
              tooltipFormat: "qqq - yyyy",
              unit: "quarter"
            },
            ticks: {
              //@ts-ignore
              callback: function callback(value, index, ticks) {
                //@ts-ignore
                if (!(index % 2)) return this.getLabelForValue(value);
              }
            }
          }
        },
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            mode: "index",
            intersect: false,
            displayColors: false,
            callbacks: {
              label: function label(context) {
                return "NTN: " + context.parsed.y.toLocaleString();
              }
            }
          }
        }
      },
      dataDoughnutFirst: {
        datasets: [{
          data: dataOne,
          //[45917, 194765, 448426, 160849, 122586],
          backgroundColor: backgroundColorDoughnutCharts
        }],
        labels: []
      },
      dataDoughnutSecond: {
        datasets: [{
          data: dataTwo,
          //[45917, 194765, 448426, 160849, 122586],
          backgroundColor: backgroundColorDoughnutCharts
        }],
        labels: []
      },
      dataDoughnutThird: {
        datasets: [{
          data: dataThree,
          //[2294, 12239, 21797, 11838, 5917],
          backgroundColor: backgroundColorDoughnutCharts
        }],
        labels: []
      },
      dataDoughnutFourth: {
        datasets: [{
          data: dataFour,
          //[2377, 14156, 26969, 14046, 6920],
          backgroundColor: backgroundColorDoughnutCharts
        }],
        labels: []
      },
      optionsDoughnut: {
        cutout: 50,
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          margin: {
            bottom: 200
          }
        },
        plugins: {
          title: {
            display: true,
            text: "2020",
            font: {
              size: 18,
              family: "'Poppins', 'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif'"
            },
            color: "#4A90CE"
          },
          legend: {
            display: true,
            position: "bottom",
            onClick: e => e.stopPropagation(),
            labels: {
              boxWidth: 15,
              font: {
                size: 14,
                family: "'Poppins', 'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif'"
              }
            }
          },
          tooltip: {
            enabled: true,
            callbacks: {
              label: function label(context) {
                // eslint-disable-next-line max-len
                var total = context.dataset.data.reduce((previousValue, currentValue, currentIndex, array) => previousValue + currentValue);
                var currentValue = context.parsed;
                var percentage = Number(currentValue / total * 100).toLocaleString("it-It", {
                  maximumFractionDigits: 2
                });
                return percentage + "%";
              }
            }
          }
        }
      }
    };
  },
  validations() {
    return {
      username: {
        required,
        max: maxLength(100)
      },
      email: {
        required,
        email
      },
      phone: {
        numeric,
        max: maxLength(15)
      },
      agency_name: {
        required,
        max: maxLength(100)
      },
      message: {
        required,
        max: maxLength(400)
      }
    };
  },
  computed: Object.assign(Object.assign(Object.assign({
    labels() {
      return window["_labels"];
    }
  }, mapState(useLoggedUserStore, ["isUserLogged"])), mapState(usePublicUserMenuStore, ["favoritesCounter", "requestsCounter", "savedSearchesCounter", "mailConfirmed", "name", "marketing"])), mapState(useModalStore, ["showModal"])),
  created() {
    this.initPublicUserMenu();
    //I reduce the range of the linear graphs in a mobile view
    if (window.screen.width < BREAKPOINT.SMALL) {
      // eslint-disable-next-line max-len
      this.dataLinear.labels = ["2019-01", "2019-04", "2019-07", "2019-10", "2020-01", "2020-04", "2020-07", "2020-10", "2021-01", "2021-04", "2021-07", "2021-10", "2022-01", "2022-04", "2022-07"];
      // eslint-disable-next-line max-len
      this.dataLinear.datasets[0].data = [138524, 159619, 137098, 168298, 117047, 116173, 141323, 183381, 162257, 201492, 172271, 212500, 181766, 218720];
    }
    if (window.innerWidth < BREAKPOINT.LARGE) {
      this.options.drag = true;
    }
    var translations = [this.labels.typologyType_1_1, this.labels.typologyType_1_2, this.labels.typologyType_1_3, this.labels.typologyType_1_4];
    this.dataDoughnutFirst.labels = [...translations];
    this.dataDoughnutFirst.labels = [...translations];
    this.dataDoughnutSecond.labels = [...translations];
    this.dataDoughnutThird.labels = [...translations];
    this.dataDoughnutFourth.labels = [...translations];
  },
  mounted() {
    if (window.screen.width < BREAKPOINT.MEDIUM) this.mobile = true;
    this.optionsDoughnut.plugins.title.text = "2023";
  },
  methods: Object.assign(Object.assign({
    submitForm() {
      this.marketingConsent = this.marketingConsent || this.marketing;
      this.v$.$touch();
      if (this.v$.$invalid) return;
      this.isLoading = true;
      axios.post("/rest/mail/infoInsight", {
        agency_name: this.agency_name,
        email: this.email,
        message: this.message,
        name: this.username,
        phone: this.phone,
        privacy: this.privacy,
        marketingConsent: this.marketingConsent
      }).then(result => {
        this.success = result.data;
        this.error = !result.data;
        result.data ? this.resetInput() : "";
        //@ts-ignore
        this.isUserLogged && this.setMarketing(this.marketingConsent);
      }).catch(() => {
        this.error = true;
      }).finally(() => {
        this.isLoading = false;
      });
    },
    resetInput() {
      this.username = "";
      this.email = "";
      this.phone = "";
      this.message = "";
      this.agency_name = "";
      this.v$.$reset();
    }
  }, mapActions(useBaseStore, ["logout", "initPublicUserMenu"])), mapActions(useModalStore, ["setShowModal"]))
});
insightApp.use(createPinia());
insightApp.mount("#insight-main");